export const CloseIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  _className,
  size=30,
  ...props
}: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className={_className}
      fill="var(--color-txt-secondary)"
      strokeWidth={1.5}
      d="M8 23.75L6.25 22L13.25 15L6.25 8L8 6.25L15 13.25L22 6.25L23.75 8L16.75 15L23.75 22L22 23.75L15 16.75L8 23.75Z"
    />
  </svg>
);
